import {Component, Module} from 'app/decorators';
import CompanyStore from 'app/stores/company';
import tpl from './error.messages.html';


@Module({
    name: "app.directives.error.messages",
})
@Component({
    selector: 'blnd-errors',
    bindings: {
        ngModel: '=',
    },
    template: tpl,
})
export default class C {}



// WEBPACK FOOTER //
// ./src/app/directives/error.messages.js